<script setup lang="ts" generic="T = Record<string, unknown>">
import { readXlsxFile } from '~/lib/xlsx';

interface Props {
  path: string
  transformer?: (data: Record<string, unknown>) => T
}

interface Slots {
  default: (props: { data: T[] }) => unknown
}

const props = defineProps<Props>()
const slots = defineSlots<Slots>()

let records = await readXlsxFile(props.path)

let data: T[];
if (props.transformer) {
  data = records.map(props.transformer)
} else {
  data = records as T[]
}
</script>

<template>
  <slot :data="data" />
</template>
